import { Component } from 'react';

export class BaseComponent extends Component {
    static displayName = BaseComponent.name;

    componentDidMount() {
        const customEvent = new window.CustomEvent('component-refreshed');
        window.dispatchEvent(customEvent);
    }

    componentDidUpdate() {
        const customEvent = new window.CustomEvent('component-refreshed');
        window.dispatchEvent(customEvent);
    }

}
